enum ReportsDeliveryScheduleState {
	ACTIVE = 'ACTIVE',
	INACTIVE = 'INACTIVE',
}

export default ReportsDeliveryScheduleState;
